import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const DirectoryIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-directory-icon ${className}`, fill: 'none', height: '18', viewBox: '0 0 22 18', width: '22', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M21.0625 3.15937H11.2461L8.03867 0.0914062C7.99786 0.0532009 7.94418 0.0317293 7.88828 0.03125H0.9375C0.453516 0.03125 0.0625 0.422266 0.0625 0.90625V17.0938C0.0625 17.5777 0.453516 17.9688 0.9375 17.9688H21.0625C21.5465 17.9688 21.9375 17.5777 21.9375 17.0938V4.03437C21.9375 3.55039 21.5465 3.15937 21.0625 3.15937Z', fill: '#828282' }) })));
DirectoryIcon.propTypes = {
    className: propStr(),
};
DirectoryIcon.defaultProps = {
    className: '',
};
export default DirectoryIcon;
